import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { bodyStyles, headerStyles, headingStyles, sectionStyles, } from './pageSectionStyles';
export default function PageSection({ heading, children, cssOverrides, }) {
    return (_jsx("section", { css: sectionStyles, children: _jsxs("div", { css: cssOverrides, children: [_jsx("div", { css: headerStyles, children: heading && _jsx("h2", { css: headingStyles, children: heading }) }), _jsx("div", { css: bodyStyles, children: children })] }) }));
}
